import styled from '@emotion/styled'
import { ThemeProvider } from '@mui/material/styles'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { StaticDateTimePicker } from '@mui/x-date-pickers/StaticDateTimePicker'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { IPostVariant } from 'types/PostInterface'
import { AppStore } from 'utils'
import { formatDate } from 'utils/AnalyticsUtils'
import { updatePost } from 'utils/PostUtils/Post'
import { muiTheme } from '../utils/MuiUtils/MuiThemes'
import { localDate, localLang } from '../utils/MuiUtils/MuiTranslations'
import { Box } from './Box'
import { Icons } from './Icons'
import { Text } from './Text'

/* ----------------- INTERFACE  */
interface Props {
  post: IPostVariant
  isOpen: string
  handleOpenClose: (value?: string) => void
  applyToAll?: boolean
  allPosts?: IPostVariant[]
}

export default function MuiDateTimePicker({ isOpen, post, handleOpenClose, applyToAll, allPosts }: Props) {
  /* ----------------- METHODS  */
  const handleAccept = (value) => {
    if (applyToAll) {
      return allPosts?.forEach((p) => {
        updatePost(p.variantId, { date: new Date(new Date(value).toUTCString()).toISOString() })
      })
    }

    updatePost(post.variantId, { date: new Date(new Date(value).toUTCString()).toISOString() })
    handleOpenClose('')
  }

  useEffect(() => {
    // Al mounting setta il valore di default della data del post, così se switcha a apply to all setta la prima data a tutti, così si evitano confusioni

    const defaultDate = allPosts ? allPosts[0]?.data.date : post.data.date

    updatePost(post.variantId, { date: defaultDate })
  }, [])

  return (
    <>
      <ShowMuiDatePicker onClick={() => handleOpenClose(post.variantId)} row>
        <Text
          color={AppStore.theme.o.darkGrey}
          style={{
            position: 'relative',
            top: '1px',
            lineHeight: '16px',
          }}
        >
          {post.data.date ? formatDate(post.data.date as Date) : formatDate(new Date())}
        </Text>

        <Icons.scheduleTime width={32} height={32} fill={AppStore.theme.o.darkGrey} />
      </ShowMuiDatePicker>

      {isOpen === post.variantId && (
        <MuiContainer id={`mui-date-picker-${post.variantId}`} className="Mui-Schedule-Picker">
          <ThemeProvider theme={muiTheme}>
            <LocalizationProvider dateAdapter={AdapterDayjs} localeText={localLang} adapterLocale={localDate}>
              <StaticDateTimePicker
                defaultValue={dayjs(post.data.date)}
                onAccept={handleAccept}
                disablePast={true}
                onChange={console.log}
              />
            </LocalizationProvider>
          </ThemeProvider>
        </MuiContainer>
      )}
    </>
  )
}

const MuiContainer = styled.div`
  top: 0px;
  left: 716px;
  position: absolute;
  z-index: 1000;
  & .MuiTabs-indicator {
    display: none;
  }

  & .MuiPickersLayout-root {
    border-radius: 14px;
  }
`

const ShowMuiDatePicker = styled(Box)`
  display: flex;
  padding: 8px 8px 8px 16px;
  align-items: center;
  gap: 24px;
  border: 1px solid ${() => AppStore.theme.o.lightGrey};
  background-color: ${() => AppStore.theme.o.lightestGrey};
  border-radius: 14px;
  min-height: 30px;
`
